type LoginContact = {
  canLogin?: boolean;
  email?: string;
  phone?: string;
  emailEditable?: boolean;
  phoneEditable?: boolean;
  /** Why a filled sign-in field stays put. `owner` is the platform owner. */
  loginLock?: "owner" | "edit" | "scope" | null;
};

type LoginCaps = {
  editUserData?: boolean;
  editUserDataMaster?: boolean;
};

/**
 * A filled sign-in email or phone stays locked unless this person may overwrite it.
 * people.EditUserDataMaster unlocks it. The platform owner stays locked for everyone else.
 */
export function loginFieldLocked(
  record: LoginContact | null | undefined,
  field: "email" | "phone",
  caps?: LoginCaps | null,
): boolean {
  if (!record) return false;
  if (caps?.editUserDataMaster && record.loginLock !== "owner") return false;
  const flag = field === "email" ? record.emailEditable : record.phoneEditable;
  if (typeof flag === "boolean") return !flag;
  if (caps?.editUserData && record.loginLock !== "scope" && record.loginLock !== "owner") return false;
  const value = field === "email" ? record.email : record.phone;
  return Boolean(record.canLogin) && Boolean(String(value || "").trim());
}
